import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { moneyFormat } from "../../util/format";

export const CartPage = () => {
  const navigate = useNavigate();
  const [shipping] = useState(0);
  const [discountArray] = useState([]);
  const [products, setProducts] = useState(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    return cart;
  });
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const totalPriceTemp = products?.reduce(
      (sum, item) => sum + Number(item.price * item.quantity),
      0,
    );
    const totalDiscount = discountArray?.reduce(
      (sum, item) => sum + Number(item.discountAmount),
      0,
    );
    const finalPrice = totalPriceTemp - totalDiscount;
    setTotalPrice(finalPrice);
  }, [products, discountArray]);

  const handleCheckout = () => {
    navigate(`/checkout`);
  };

  const handleIncrease = (index) => {
    const updatedProducts = [...products];
    updatedProducts[index].quantity += 1;
    setProducts(updatedProducts);
    localStorage.setItem("cart", JSON.stringify(updatedProducts));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const handleDecrease = (index) => {
    const updatedProducts = [...products];
    if (updatedProducts[index].quantity > 1) {
      updatedProducts[index].quantity -= 1;
      setProducts(updatedProducts);
      localStorage.setItem("cart", JSON.stringify(updatedProducts));
      window.dispatchEvent(new Event("cartUpdated"));
    }
  };

  const handleQuantityChange = (index, value) => {
    if (/^\d*$/.test(value)) {
      const updatedProducts = [...products];
      if (value === "") {
        updatedProducts[index].quantity = "";
      } else {
        const number = parseInt(value, 10);
        updatedProducts[index].quantity = Math.max(number, 1);
        localStorage.setItem("cart", JSON.stringify(updatedProducts));
        window.dispatchEvent(new Event("cartUpdated"));
      }
      setProducts(updatedProducts);
    }
  };

  const handleRemoveItem = (index) => {
    const updatedProducts = [...products];
    updatedProducts.splice(index, 1);
    setProducts(updatedProducts);
    localStorage.setItem("cart", JSON.stringify(updatedProducts));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  if (products.length === 0) {
    return (
      <>
        <div className="container-fluid">
          <div className="row px-xl-5">
            <div className="col-12">
              <nav className="breadcrumb bg-light mb-30">
                <Link className="breadcrumb-item text-dark" to="/">
                  Trang chủ
                </Link>
                <span className="breadcrumb-item active">Giỏ hàng</span>
              </nav>
            </div>
          </div>
        </div>
        <div className="container d-flex flex-column align-items-center">
          <p>Chưa có sản phẩm trong giỏ hàng</p>
          <button
            className="btn btn-primary font-weight-bold my-3 py-3"
            onClick={() => navigate("/")}
          >
            <i className="fa fa-home mr-1"></i> Về trang chủ
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <nav className="breadcrumb bg-light mb-30">
              <Link className="breadcrumb-item text-dark" to="/">
                Trang chủ
              </Link>
              <span className="breadcrumb-item active">Giỏ hàng</span>
            </nav>
          </div>
        </div>
      </div>

      <style>{`
        .cart-product-card {
          padding: 1rem;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgb(0 0 0 / 0.1);
          background-color: #fff;
          position: relative;
          display: flex;
          gap: 1.25rem;
          align-items: start;
          flex-direction: row;
          margin-bottom: 1rem;
        }
        .cart-product-card img {
          width: 120px;
          height: 80px;
          object-fit: cover;
          border-radius: 8px;
          flex-shrink: 0;
          background-color: #f9f9f9;
          border: 1px solid #eee;
        }
        .product-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-left: 0px;
        }
        .product-info h5 {
          margin: 0 1.3rem 0.3rem 0;
          font-weight: 400;
          font-size: 1.1rem;
          color: #333;
          line-height: 1.4;
          max-height: 3.6em;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;     
          -webkit-box-orient: vertical;
          white-space: normal;
        }
        .option-chip {
          display: inline-block;
          background: #eff6ff;
          border: 1px solid #3b82f6;
          color: #2563eb;
          border-radius: 999px;
          font-size: 12px;
          padding: 2px 10px;
          margin-right: 4px;
          margin-bottom: 2px;
          font-weight: 500;
        }
        .product-price {
          font-weight: 400;
          font-size: 1rem;
          color: #d9534f;
        }
        .quantity-group {
          width: 120px;
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 1.6rem;
        }
        .quantity-group button {
          padding: 6px 12px;
          font-size: 1.1rem;
          border-radius: 8px;
          user-select: none;
          min-width: 34px;
          height: 34px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #007bff;
          background-color: #007bff;
          color: #fff;
          transition: background-color 0.3s;
          cursor: pointer;
        }
        .quantity-group button:hover {
          background-color: #0056b3;
          border-color: #0056b3;
        }
        .quantity-group input {
          width: 45px;
          text-align: center;
          border-radius: 8px;
          border: 1px solid #ccc;
          font-size: 1rem;
          height: 34px;
          padding: 0;
          line-height: 34px;
        }
        .total-price {
          display: flex;
          justify-content: flex-end;
          font-weight: 600;
          font-size: 1rem;
          color: #444;
        }
        .remove-button {
          position: absolute;
          top: 12px;
          right: 12px;
          border: none;
          background-color: transparent
          width: 32px;
          height: 32px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          line-height: 1;
        }
        .remove-button:hover {
          opacity: .8
        }
        @media (max-width: 767px) {
          .cart-product-card img {
            width: 70px !important;
            height: 60px !important;
          }
          .quantity-group {
            width: 100px !important;
            gap: 6px !important;
          }
          .quantity-group button {
            padding: 5px 9px !important;
            min-width: 28px !important;
            height: 28px !important;
            font-size: 0.9rem !important;
          }
          .quantity-group input {
            width: 35px !important;
            height: 28px !important;
            font-size: 0.9rem !important;
          }
          .product-info h5 {
            font-size: 1rem !important;
            max-height: 3em !important;
          }
          .product-price {
            font-size: 0.95rem !important;
          }
          .total-price {
            font-size: 0.95rem !important;
            justify-content: flex-end !important;
          }
        }
      `}</style>

      <div className="container">
        <div className="row px-xl-5">
          {/* Cột bên trái: danh sách sản phẩm dạng card */}
          <div className="col-lg-7 mb-5">
            {products.map((item, index) => (
              <div key={index} className="cart-product-card">
                <span
                  onClick={() => handleRemoveItem(index)}
                  aria-label={`Xóa sản phẩm ${item.name}`}
                  className="remove-button text-gray-500"
                >
                  Xoá
                </span>

                <Link
                  to={`/san-pham/${item.slug}`}
                  aria-label={`Xem chi tiết sản phẩm ${item.name}`}
                >
                  <img src={item.image} alt={item.name} />
                </Link>

                <div className="product-info ">
                  <h5 title={item.name}>{item.name}</h5>
                  <div className="product-price">{moneyFormat(item.price)}</div>
                  <div className="product-price !mt-0 line-through !text-gray-500 !text-sm mb-3">
                    {item.originalPrice && moneyFormat(item.originalPrice)}
                  </div>
                  {/* Hiển thị các option dạng chip */}
                  {item.options?.length > 0 && (
                    <div className="mb-4">
                      {item.options.map((opt, i) => (
                        <span key={i} className="option-chip">
                          <b>{opt.value}</b>
                        </span>
                      ))}
                    </div>
                  )}

                  <div className="flex justify-end mr-2">
                    <div className="quantity-group">
                      <button
                        onClick={() => handleDecrease(index)}
                        aria-label="Giảm số lượng"
                      >
                        <i className="fa fa-minus"></i>
                      </button>

                      <input
                        type="text"
                        value={item.quantity}
                        onChange={(e) =>
                          handleQuantityChange(index, e.target.value)
                        }
                        onBlur={() => {
                          const updatedProducts = [...products];
                          if (!updatedProducts[index].quantity) {
                            updatedProducts[index].quantity = 1;
                            setProducts(updatedProducts);
                            localStorage.setItem(
                              "cart",
                              JSON.stringify(updatedProducts),
                            );
                          }
                        }}
                        aria-label="Số lượng"
                      />

                      <button
                        onClick={() => handleIncrease(index)}
                        aria-label="Tăng số lượng"
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>

                  <div className="total-price">
                    Tổng tiền: {moneyFormat(item.price * item.quantity)}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Cột bên phải giữ nguyên */}
          <div className="col-lg-5">
            <h5 className="section-title position-relative text-uppercase mb-3">
              <span className="bg-secondary pr-3">Đơn hàng</span>
            </h5>
            <div className="bg-light p-30 mb-5">
              <div className="border-bottom pb-2">
                <div className="d-flex justify-content-between mb-3">
                  <h6>Tạm tính</h6>
                  <h6>{moneyFormat(totalPrice)}</h6>
                </div>
                {discountArray.length > 0 && (
                  <>
                    <hr />
                    <h6 className="font-weight-medium">Mã giảm giá:</h6>
                  </>
                )}
                {discountArray.map((item, idx) => (
                  <div className="d-flex justify-content-between" key={idx}>
                    <h6 className="font-weight-medium">{item.code}</h6>
                    <h6 className="font-weight-medium">
                      {moneyFormat(item.discountAmount)}
                    </h6>
                  </div>
                ))}
              </div>
              <div className="pt-2">
                <div className="d-flex justify-content-between mt-2">
                  <h5>Tổng cộng</h5>
                  <h5>{moneyFormat(totalPrice + shipping)}</h5>
                </div>

                <div className="max-md:hidden mt-4 grid grid-cols-1 gap-4 fixed bottom-0 p-3 left-0 w-full z-[1024] justify-center items-center md:static md:z-0 md:grid-cols-1 md:p-0">
                  <button
                    className="btn btn-block btn-success font-weight-bold py-3"
                    onClick={handleCheckout}
                  >
                    Đặt hàng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Thanh đặt hàng fixed cho mobile */}
      <div className="fixed md:hidden bottom-0 left-0 w-full z-50 bg-white px-8 py-2 shadow-[0_-2px_12px_#0001] flex items-center justify-between">
        <div className="flex flex-col justify-center mr-4">
          <span className="text-gray-800 text-sm font-medium">Tổng cộng</span>
          <span className="text-red-600 font-bold">
            {moneyFormat(totalPrice + shipping)}
          </span>
        </div>
        <button
          className="bg-success w-1/3 outline-none focus:outline-none active:outline-none hover:bg-green-600 border-none text-white font-semibold p-2 rounded text-base shadow transition-all"
          onClick={handleCheckout}
        >
          Đặt hàng
        </button>
      </div>
    </>
  );
};
